import React from 'react';
import { ChromePicker } from 'react-color';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit, ColorContrast } from 'components';
import { useToggle } from 'utils/hooks';

export default function ColorPicker({
  label = '',
  color = '',
  error = '',
  onChange = () => {},
  disabled = false,
  showContrast = false
}) {
  const [isOpen, onToggle] = useToggle();

  const onBackdropClick = e => {
    e.preventDefault();
    onToggle();
  };

  return (
    <div className={styles.container}>
      <UiKit.Input
        label={label}
        value={color}
        error={error}
        disabled={disabled}
        onClick={() => !disabled && onToggle()}
        className={styles.content}
        inputClassName={styles.input}
      >
        <div style={{ backgroundColor: color }} className={styles.preview} />
        <If test={isOpen}>
          <div className={styles.pickerBackdrop} onClick={onBackdropClick} />
          <ChromePicker
            disableAlpha
            color={color}
            onChange={({ hex }) => onChange(hex)}
            className={styles.colorPicker}
          />
        </If>
      </UiKit.Input>
      <If test={showContrast}>
        <ColorContrast color={color} className="ml-auto" />
      </If>
    </div>
  );
}
